module.exports = __webpack_public_path__ + "media/images/fake_courses/test2-47dd2244b9e4928b756211b25d7b1e01.jpg";